import api from "!../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../node_modules/css-loader/index.js??ruleSet[1].rules[0].oneOf[3].use[1]!../../../../../node_modules/postcss-loader/lib/index.js??ruleSet[1].rules[0].oneOf[3].use[2]!../../../../../node_modules/sass-loader/dist/cjs.js!./HeadMessage.module.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};